<script context="module">
  import { writable } from 'svelte/store'
  export const title = writable(null)
</script>

<script>
  import { Inertia } from '@inertiajs/inertia'
  import { inertia, page } from '@inertiajs/inertia-svelte'
  import { route } from '@/Utils'
  import Dropdown from '@/Shared/Dropdown.svelte'
  import FlashMessages from '@/Shared/FlashMessages.svelte'
  import Icon from '@/Shared/Icon.svelte'
  import Logo from '@/Shared/Logo.svelte'
  import SelectInput from '@/Shared/SelectInput.svelte'
  import MainMenu from '@/Shared/MainMenu.svelte'
  import Footer from '@/Shared/Footer.svelte'

  let active
  let sending = false
  $: if (active) {
    if (!sending) {
      const data = new FormData()
      data.append('account', active)

      let params = route().params
      params.remember = 'forget'
      Inertia.get(
        route(route().current(), params),
        {}, {
          preserveState: true,
          onStart: () => sending = true,
          onFinish: () => {
            Inertia.post(route('accounts.switch'), data, {
              onFinish: () => {
                sending = false
                active = null
              },
            })
          },
        }
      )
    }
  }
</script>

<!-- {(console.log($page.props.auth), '')} -->

<svelte:head>
  <title>{$title ? `${$title} - éhop, covoiturons-nous.` : '- éhop, covoiturons-nous.'}</title>
</svelte:head>

<div class="flex flex-col">
  <div class="h-screen flex flex-col">
    <div class="md:flex flex-shrink-0">
      <div class="bg-disco-900 md:flex-shrink-0 md:w-56 md:px-12 p-4 flex items-center justify-between md:justify-center">
        <a use:inertia href="/" class="mt-1">
          <Logo height="28" class="fill-current text-white" />
        </a>
        <Dropdown class="md:hidden fill-white" placement="bottom-end">
          <svg class="w-6 h-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
          <div slot="dropdown" class="mt-2 px-8 py-4 shadow-lg bg-disco-800 rounded">
            <MainMenu />
          </div>
        </Dropdown>
      </div>
      <div class="bg-white border-b w-full p-4 md:py-0 md:px-12 text-sm md:text-md flex justify-between items-center">

        {#if $page.props.auth.user.accounts}
          <SelectInput
            bind:value={active}
            class="mr-4">
            {#each $page.props.auth.user.accounts as account}
              <option value={account.id} selected={Number(account.id) === $page.props.auth.user.account.id}>{account.name}</option>
            {/each}
          </SelectInput>
        {/if}

        <div class="mt-1 mr-4">{$page.props.auth.user.account.name} / {$page.props.auth.user.account.description}</div>
        <Dropdown class="mt-1" placement="bottom-end">
          <div class="flex items-center cursor-pointer select-none group">
            <div class="text-gray-700 group-hover:text-disco-600 focus:text-disco-600 mr-1 whitespace-nowrap">
              <span>{$page.props.auth.user.first_name}</span>
              <span class="hidden md:inline">{$page.props.auth.user.last_name}</span>
            </div>
            <Icon
              name="account"
              class="w-5 h-5 group-hover:fill-disco-600 fill-gray-700 focus:fill-disco-600" />
          </div>
          <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
            <a
              use:inertia
              href={route('users.edit', $page.props.auth.user.id)}
              class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
              Mon compte
            </a>
            {#if $page.props.auth.user.type === 4}
              <a
                use:inertia
                href={route('accounts.edit', {account: $page.props.auth.user.account.id})}
                class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
                Mon entité
              </a>
            {/if}
            {#if $page.props.auth.user.owner}
              <a
                use:inertia
                href={route('accounts')}
                class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
                Gestion des entités
              </a>
            {/if}
            {#if $page.props.auth.user.type === 3 || $page.props.auth.user.type === 4}
              <a
                use:inertia
                href={route('users')}
                class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
                Gestion des utilisateurs
              </a>
              {#if $page.props.auth.user.type === 4}
                <a
                  use:inertia
                  href={route('users.import')}
                  class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
                  Import en masse
                </a>
              {/if}
            {/if}
            {#if $page.props.auth.user.owner}
              <a
                use:inertia
                href={route('users.remove')}
                class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
                Suppression en masse
              </a>
              <a
                use:inertia
                href={route('rdex')}
                class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
                Accès RDEX
              </a>
            {/if}
            <a
              use:inertia={{ method: 'post' }}
              href={route('logout')}
              class="block px-6 py-2 hover:bg-disco-500 hover:text-white">
              Déconnexion
            </a>
          </div>
        </Dropdown>
      </div>
    </div>
    <div class="flex flex-grow overflow-hidden">
      <MainMenu class="bg-disco-800 flex-shrink-0 w-56 p-12 hidden md:block overflow-y-auto" />
      <div class="flex-1 px-4 py-8 md:p-12 overflow-y-auto" scroll-region>
        <FlashMessages />
        <slot />
        <Footer class="flex justify-center items-center flex-wrap px-4 py-6 md:px-12 bg-white mt-12 -mb-12 -mx-4 md:-mx-12" />
      </div>
    </div>
  </div>
</div>
